/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="73.59"
        height="92.51"
        viewBox="0 0 73.59 92.51"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="m29.98 68.01 17 .35a1.25 1.25 0 0 1 1 .6l.07.13 2.9 6.29a1.25 1.25 0 0 1-2.21 1.16l-.06-.11-2.57-5.59-15.53-.31-3.25 5.46a1.25 1.25 0 0 1-1.6.5l-.12-.06a1.24 1.24 0 0 1-.49-1.59l.06-.12 3.63-6.1a1.2 1.2 0 0 1 1-.6Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M32.18 10.44a1.25 1.25 0 0 1 1.61.44l.07.12 25.05 49.79a1.252 1.252 0 0 1-2.17 1.25l-.06-.12-25.06-49.8a1.25 1.25 0 0 1 .56-1.68Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M60.56 60.07a1.252 1.252 0 0 1 .13 2.5h-28a1.25 1.25 0 0 1-.13-2.49h28Z"
          className="icon-fill icon-base"/><g>
          <path
            fill="#fff"
            d="M33.24 4.8a1.25 1.25 0 0 1-.34 1.63l-.2.13-.23.14-.54.33-.42.27c-1 .67-2.18 1.47-3.43 2.4a76.5 76.5 0 0 0-10.44 9.38C5.39 32.35-.36 47.96 3.9 65.73l.06.26.29-.12c1.33-.55 2.84-1.1 4.51-1.61a48.11 48.11 0 0 1 23.58-1.54 1.26 1.26 0 0 1 1 1.47 1.25 1.25 0 0 1-1.47 1 45.6 45.6 0 0 0-22.35 1.48c-1.6.49-3 1-4.3 1.53l-.49.21-.45.2-.53.25a1.24 1.24 0 0 1-1.77-.79c-5.29-19.4.71-36.42 13.89-50.68a79 79 0 0 1 10.78-9.7q1.69-1.26 3.15-2.22l.63-.41.42-.27.63-.39.11-.06a1.25 1.25 0 0 1 1.65.46Z"
            className="icon-fill icon-base"/>
          <path
            fill="#fff"
            d="M28.37 6.62a1.254 1.254 0 0 1 2.3 1c-5.51 12.82-7.9 23.75-7.7 32.95.15 7.12 1.83 12.79 4.52 17.18a21.12 21.12 0 0 0 3.06 3.93 10.15 10.15 0 0 0 .79.74l.35.29.15.11a1.252 1.252 0 0 1-1.41 2.07l-.1-.08-.24-.17a14.38 14.38 0 0 1-1.31-1.19 23.57 23.57 0 0 1-3.42-4.4c-6.93-11.3-7.29-28.45 3.01-52.43Z"
            className="icon-fill icon-base"/>
          <path
            fill="#fff"
            d="M38.76 0A1.24 1.24 0 0 1 40 1.12v2.23h5.36a1.25 1.25 0 0 1 1.24 1.12v.13a1.26 1.26 0 0 1-1.12 1.25h-6.72a1.24 1.24 0 0 1-1.24-1.12V2.5h-3.74v66.7a1.25 1.25 0 0 1-1.12 1.24h-.1a1.25 1.25 0 0 1-1.24-1.13V1.25A1.24 1.24 0 0 1 32.44.01h6.37Z"
            className="icon-fill icon-base"/>
          <path
            fill="#fff"
            d="m4.11 73.37.45.08.4.06.64.08.75.08 1.1.09 1.56.11 1.79.1 1.33.07 2.57.11 3.76.14 4.73.14 4.18.11 5.12.11 4.85.09 3.75.06 3.8.05h3.84l6.64.07 8.66.07a1.25 1.25 0 0 1 1.11.69v.12l4.79 12.76a1.25 1.25 0 0 1-2.28 1l-.06-.12-4.49-12h-8.54l-5.82-.06-5.76-.08-5.64-.08-5.7-.11-3.88-.08-4.21-.1-3.86-.12-3-.1-1.86-.07-2.94-.13-1.86-.1-1.66-.1-1.16-.09h-.29c.53.62 1.11 1.28 1.75 2l.38.42a87.82 87.82 0 0 0 12 10.64 1.25 1.25 0 0 1-1.49 2A90.82 90.82 0 0 1 7.22 80.34q-1.64-1.74-2.85-3.23l-.48-.59-.33-.42-.37-.47-.21-.28a1.25 1.25 0 0 1 1.13-1.98Z"
            className="icon-fill icon-base"/>
          <path
            fill="#ffb81c"
            d="M71.61 85.9a1.25 1.25 0 1 1 1.48 2c-7.76 5.7-15 5.7-21.16 2.24a20.09 20.09 0 0 1-2.26-1.5l-.24-.2-.37.25c-7.21 4.82-14 4.74-19.73 1.61l-.3-.16a19.21 19.21 0 0 1-2.26-1.5l-.21-.2-.37.25c-7.21 4.82-14 4.74-19.73 1.61l-.3-.16a15.1 15.1 0 0 1-3.24-2.37 1.25 1.25 0 1 1 1.78-1.75l.12.11.17.15.23.2.14.11a15.24 15.24 0 0 0 2 1.37c5.31 3 11.53 3 18.45-2.07a1.24 1.24 0 0 1 .58-.24h.29a1.23 1.23 0 0 1 .89.38l.12.11.18.15.23.2.14.11a15.24 15.24 0 0 0 2 1.37c5.31 3 11.53 3 18.44-2.07a1.24 1.24 0 0 1 .58-.24h.3a1.23 1.23 0 0 1 .89.38l.12.11.17.15.23.2.14.11a15.24 15.24 0 0 0 2 1.37c5.37 2.99 11.59 2.99 18.5-2.08Z"
            className="icon-fill icon-accent"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'SailboatOnWaterIcon';

export default Icon;
